var _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _circle2, _path21, _path22, _circle3, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisableDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 99,
    viewBox: "0 0 113 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2886 84C76.2638 84 94.0782 66.1856 94.0782 44.2105C94.0782 22.2353 76.2638 4.4209 54.2886 4.4209C32.3134 4.4209 14.499 22.2353 14.499 44.2105C14.499 66.1856 32.3134 84 54.2886 84Z",
    fill: "url(#paint0_linear_4150_53677)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41655 24.8779C8.38965 20.6907 16.2891 19.8935 23.8523 20.1441C24.933 20.1799 25.7801 21.085 25.7442 22.1657C25.7084 23.2464 24.8033 24.0935 23.7226 24.0577C16.464 23.8172 9.45887 24.6161 3.43237 28.2349C2.50537 28.7916 1.30263 28.4913 0.745973 27.5643C0.18932 26.6373 0.489548 25.4346 1.41655 24.8779Z",
    fill: "url(#paint1_linear_4150_53677)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4150_53677)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1084,
    cy: 38.4162,
    rx: 23.9912,
    ry: 4.09976,
    fill: "#C4C1FE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4150_53677)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.8021,
    cy: 38.1125,
    rx: 10.9327,
    ry: 4.09976,
    fill: "#40DFF0",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4150_53677)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.6854,
    cy: 79.4142,
    rx: 23.9912,
    ry: 4.09976,
    fill: "#C4C1FE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.254 56.6905C105.811 57.6175 105.511 58.8202 104.584 59.3769C97.6112 63.5637 89.7078 64.3611 82.145 64.1107C81.0643 64.0749 80.2173 63.1698 80.253 62.0891C80.2888 61.0084 81.1939 60.1613 82.2746 60.1971C89.5331 60.4374 96.5421 59.6382 102.568 56.0199C103.495 55.4632 104.697 55.7635 105.254 56.6905Z",
    fill: "url(#paint2_linear_4150_53677)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.491 79.1589H71.3772C78.0451 79.1589 83.4516 71.9372 83.4516 63.0262C83.4516 54.1151 78.0451 46.8906 71.3772 46.8906H51.491C55.6164 46.8906 59.2581 49.654 61.4341 53.883C62.8343 56.7305 63.5624 59.8614 63.5624 63.0345C63.5624 66.2077 62.8343 69.3386 61.4341 72.1861C59.2581 76.4039 55.6164 79.1589 51.491 79.1589Z",
    fill: "url(#paint3_linear_4150_53677)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7889 52.8149C63.3611 48.1076 59.2972 45.0254 54.6962 45.0254H50.2519C42.812 45.0254 36.7791 53.0862 36.7791 63.0265C36.7791 72.9668 42.812 81.0248 50.2519 81.0276H54.7102C59.3112 81.0276 63.3807 77.9509 65.8029 73.2381C67.3642 70.0614 68.176 66.5689 68.176 63.0293C68.176 59.4896 67.3642 55.9972 65.8029 52.8205L65.7889 52.8149Z",
    fill: "url(#paint4_linear_4150_53677)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2943 52.8149C58.8721 48.116 54.8166 45.0366 50.224 45.0254C42.7897 45.0254 36.7651 53.0918 36.7651 63.0265C36.7651 72.9612 42.7897 81.0164 50.224 81.0276C54.8166 81.0276 58.8721 77.9509 61.2943 73.2381C62.8574 70.0619 63.6703 66.5692 63.6703 63.0293C63.6703 59.4893 62.8574 55.9966 61.2943 52.8205V52.8149Z",
    fill: "url(#paint5_linear_4150_53677)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9986 59.7077C51.328 60.887 50.2055 61.6592 48.9346 61.6592H47.707C45.652 61.6592 43.9855 59.6398 43.9855 57.1495C43.9855 54.6592 45.652 52.6405 47.707 52.6398H48.9385C50.2093 52.6398 51.3334 53.4106 52.0025 54.5913C52.4337 55.3871 52.658 56.262 52.658 57.1488C52.658 58.0356 52.4337 58.9105 52.0025 59.7063L51.9986 59.7077Z",
    fill: "url(#paint6_linear_4150_53677)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9986 71.8493C51.328 73.0286 50.2055 73.8008 48.9346 73.8008H47.707C45.652 73.8008 43.9855 71.7814 43.9855 69.2911C43.9855 66.8008 45.652 64.7821 47.707 64.7814H48.9385C50.2093 64.7814 51.3334 65.5522 52.0025 66.7329C52.4337 67.5287 52.658 68.4036 52.658 69.2904C52.658 70.1772 52.4337 71.0521 52.0025 71.8479L51.9986 71.8493Z",
    fill: "url(#paint7_linear_4150_53677)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6271 59.7077C49.9712 60.8849 48.8731 61.6564 47.6297 61.6592C45.6168 61.6592 43.9855 59.6384 43.9855 57.1495C43.9855 54.6606 45.6168 52.6426 47.6297 52.6398C48.8731 52.6398 49.9712 53.4106 50.6271 54.5913C51.0503 55.387 51.2704 56.262 51.2704 57.1488C51.2704 58.0356 51.0503 58.9106 50.6271 59.7063V59.7077Z",
    fill: "#958FFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6271 71.8493C49.9712 73.0265 48.8731 73.798 47.6297 73.8008C45.6168 73.8008 43.9855 71.78 43.9855 69.2911C43.9855 66.8022 45.6168 64.7842 47.6297 64.7814C48.8731 64.7814 49.9712 65.5522 50.6271 66.7329C51.0503 67.5286 51.2704 68.4036 51.2704 69.2904C51.2704 70.1772 51.0503 71.0522 50.6271 71.8479V71.8493Z",
    fill: "#958FFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5089 39.5837H34.6226C27.9547 39.5837 22.5455 32.362 22.5455 23.451C22.5455 14.5399 27.9547 7.31543 34.6226 7.31543H54.5089C50.3834 7.31543 46.7418 10.0788 44.5658 14.3078C43.1386 17.1468 42.4081 20.2848 42.4345 23.4621C42.408 26.6386 43.1386 29.7758 44.5658 32.6137C46.7418 36.8203 50.3834 39.5837 54.5089 39.5837Z",
    fill: "url(#paint8_linear_4150_53677)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2085 13.2514C42.639 8.54414 46.703 5.46191 51.3039 5.46191H55.7623C63.2021 5.46191 69.2351 13.5227 69.2351 23.463C69.2351 33.4033 63.2021 41.4613 55.7623 41.4641H51.3039C46.703 41.4641 42.6334 38.3875 40.2085 33.6746C38.6194 30.5068 37.8056 27.0069 37.8339 23.463C37.8056 19.9191 38.6194 16.4192 40.2085 13.2514Z",
    fill: "url(#paint9_linear_4150_53677)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.703 13.2514C47.1279 8.55253 51.1807 5.4731 55.776 5.46191C63.2103 5.46191 69.2349 13.5283 69.2349 23.463C69.2349 33.3977 63.2103 41.4529 55.776 41.4613C51.1807 41.4613 47.1279 38.3847 44.703 33.6746C43.1139 30.5068 42.3 27.0069 42.3284 23.463C42.3 19.9191 43.1139 16.4192 44.703 13.2514Z",
    fill: "url(#paint10_linear_4150_53677)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9337 20.3798C58.3872 20.3798 59.5656 18.7444 59.5656 16.727C59.5656 14.7096 58.3872 13.0742 56.9337 13.0742C55.4801 13.0742 54.3018 14.7096 54.3018 16.727C54.3018 18.7444 55.4801 20.3798 56.9337 20.3798Z",
    fill: "url(#paint11_linear_4150_53677)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.994 21.0719C58.814 21.0719 60.2895 19.1305 60.2895 16.7356C60.2895 14.3408 58.814 12.3994 56.994 12.3994C55.1739 12.3994 53.6984 14.3408 53.6984 16.7356C53.6984 19.1305 55.1739 21.0719 56.994 21.0719Z",
    fill: "#7F79F6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.994 34.9478C58.814 34.9478 60.2895 33.0064 60.2895 30.6116C60.2895 28.2168 58.814 26.2754 56.994 26.2754C55.1739 26.2754 53.6984 28.2168 53.6984 30.6116C53.6984 33.0064 55.1739 34.9478 56.994 34.9478Z",
    fill: "#7F79F6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1489 50.0618C17.4619 48.7652 19.3061 48.7652 19.6191 50.0618C19.7309 50.5251 20.0927 50.8868 20.556 50.9987C21.8526 51.3117 21.8526 53.1559 20.556 53.4689C20.0927 53.5807 19.7309 53.9425 19.6191 54.4058C19.3061 55.7023 17.4619 55.7023 17.1489 54.4058C17.0371 53.9425 16.6753 53.5807 16.212 53.4689C14.9154 53.1559 14.9154 51.3117 16.212 50.9987C16.6753 50.8868 17.0371 50.5251 17.1489 50.0618Z",
    fill: "url(#paint12_linear_4150_53677)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9337 20.3798C58.3872 20.3798 59.5656 18.7444 59.5656 16.727C59.5656 14.7096 58.3872 13.0742 56.9337 13.0742C55.4801 13.0742 54.3018 14.7096 54.3018 16.727C54.3018 18.7444 55.4801 20.3798 56.9337 20.3798Z",
    fill: "url(#paint13_linear_4150_53677)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9337 34.2558C58.3872 34.2558 59.5656 32.6204 59.5656 30.603C59.5656 28.5856 58.3872 26.9502 56.9337 26.9502C55.4801 26.9502 54.3018 28.5856 54.3018 30.603C54.3018 32.6204 55.4801 34.2558 56.9337 34.2558Z",
    fill: "url(#paint14_linear_4150_53677)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5821 5.11644C77.8951 3.81989 79.7393 3.81989 80.0523 5.11644C80.1641 5.57977 80.5259 5.94153 80.9892 6.05338C82.2858 6.36636 82.2858 8.21056 80.9892 8.52354C80.5259 8.63539 80.1641 8.99715 80.0523 9.46048C79.7393 10.757 77.8951 10.757 77.5821 9.46048C77.4703 8.99715 77.1085 8.63539 76.6452 8.52354C75.3486 8.21056 75.3486 6.36636 76.6452 6.05338C77.1085 5.94153 77.4703 5.57977 77.5821 5.11644Z",
    fill: "url(#paint15_linear_4150_53677)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3839,
    cy: 34.3162,
    r: 1.2066,
    stroke: "url(#paint16_linear_4150_53677)",
    strokeWidth: 1.83841
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.3923,
    cy: 73.1512,
    r: 1.2066,
    stroke: "url(#paint17_linear_4150_53677)",
    strokeWidth: 1.83841
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.071 46.6947C85.8379 45.7804 86.6819 44.9567 87.5902 45.212L88.5667 45.4864C89.475 45.7416 89.7664 46.8844 89.0912 47.5434L88.3653 48.2519C87.6901 48.9109 86.5547 48.5918 86.3216 47.6776L86.071 46.6947Z",
    fill: "url(#paint18_linear_4150_53677)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0853 75.2789C30.9998 75.047 31.8225 75.8921 31.566 76.8L31.2904 77.7762C31.0339 78.6842 29.8908 78.9741 29.2327 78.298L28.5251 77.5712C27.867 76.8951 28.1875 75.7602 29.102 75.5283L30.0853 75.2789Z",
    fill: "url(#paint19_linear_4150_53677)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.9892,
    cy: 2.38459,
    r: 1.2066,
    stroke: "url(#paint20_linear_4150_53677)",
    strokeWidth: 1.83841
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.8846,
    y: 54.0273,
    width: 17.3449,
    height: 6.24417,
    rx: 3.12208,
    fill: "url(#paint21_linear_4150_53677)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8846,
    y: 66.1689,
    width: 17.3449,
    height: 6.24417,
    rx: 3.12208,
    fill: "url(#paint22_linear_4150_53677)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4150_53677",
    x: 5.79718,
    y: 18.9963,
    width: 78.6225,
    height: 38.8393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.66003,
    result: "effect1_foregroundBlur_4150_53677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4150_53677",
    x: 59.5494,
    y: 18.6926,
    width: 52.5055,
    height: 38.8393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.66003,
    result: "effect1_foregroundBlur_4150_53677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4150_53677",
    x: 20.3742,
    y: 59.9944,
    width: 78.6225,
    height: 38.8393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.66003,
    result: "effect1_foregroundBlur_4150_53677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4150_53677",
    x1: 53.9819,
    y1: -8.53556,
    x2: 54.797,
    y2: 131.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4150_53677",
    x1: 22.8247,
    y1: 28.5708,
    x2: 6.21794,
    y2: 12.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4150_53677",
    x1: 82.158,
    y1: 66.9627,
    x2: 98.1814,
    y2: 77.7504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4150_53677",
    x1: 78.7585,
    y1: 69.3533,
    x2: 58.4106,
    y2: 30.9385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4150_53677",
    x1: 63.5657,
    y1: 70.0873,
    x2: 39.3215,
    y2: 29.7872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4150_53677",
    x1: 39.1166,
    y1: 65.3607,
    x2: 63.7445,
    y2: 65.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4150_53677",
    x1: 54.0456,
    y1: 59.5778,
    x2: 46.3318,
    y2: 48.8077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4150_53677",
    x1: 54.0456,
    y1: 71.7194,
    x2: 46.3318,
    y2: 60.9493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4150_53677",
    x1: 30.9767,
    y1: 41.0583,
    x2: 29.4685,
    y2: -8.63819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4150_53677",
    x1: 56.6475,
    y1: 33.6008,
    x2: 49.8827,
    y2: -10.7821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4150_53677",
    x1: 44.6793,
    y1: 25.7956,
    x2: 69.3091,
    y2: 25.6222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4150_53677",
    x1: 51.7892,
    y1: 20.5156,
    x2: 72.3281,
    y2: 18.9639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4150_53677",
    x1: 23.532,
    y1: 55.0926,
    x2: 14.3896,
    y2: 37.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4150_53677",
    x1: 55.086,
    y1: 13.96,
    x2: 74.1866,
    y2: 19.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4150_53677",
    x1: 55.086,
    y1: 27.8359,
    x2: 74.1866,
    y2: 33.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4150_53677",
    x1: 83.9652,
    y1: 10.1473,
    x2: 74.8228,
    y2: -7.27871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4150_53677",
    x1: 19.8854,
    y1: 35.1501,
    x2: 17.2189,
    y2: 30.0675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4150_53677",
    x1: 88.8938,
    y1: 73.985,
    x2: 86.2273,
    y2: 68.9024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4150_53677",
    x1: 90.0347,
    y1: 46.1652,
    x2: 82.2372,
    y2: 43.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4150_53677",
    x1: 30.6096,
    y1: 79.2433,
    x2: 33.1552,
    y2: 71.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4150_53677",
    x1: 44.4907,
    y1: 3.21842,
    x2: 41.8242,
    y2: -1.86417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4150_53677",
    x1: 47.6826,
    y1: 58.374,
    x2: 37.4667,
    y2: 48.1944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4150_53677",
    x1: 47.6826,
    y1: 70.5156,
    x2: 45.9467,
    y2: 61.3243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableDashboard);
export default __webpack_public_path__ + "static/media/disableDashboard.c633787217f64011aca0016cf7a2fb94.svg";
export { ForwardRef as ReactComponent };